import { styled } from '@fluentui/react';
import React from 'react';
import { CoherenceDataGridBase } from './CoherenceDataGrid.base';
import { getStyles } from './CoherenceDataGrid.styles';
var DataGridAny = styled(CoherenceDataGridBase, getStyles);
export function CoherenceDataGrid(props) {
    return React.createElement(DataGridAny, props);
}
//# sourceMappingURL=CoherenceDataGrid.js.map